import React, { useEffect, useRef, useState } from "react";
import EditIcon from "@material-ui/icons/Edit";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import CloseIcon from "@material-ui/icons/Close";
import { Pagination, PaginationItem } from "@material-ui/lab";
import {
  makeStyles,
  Grid,
  Box,
  Dialog,
  Drawer,
  Button,
  DialogContent,
  FormControl,
  InputBase,
  MenuItem,
  Select as MuiSelect,
  withStyles,
} from "@material-ui/core";
import DeleteForeverIcon from "@material-ui/icons/DeleteForeverOutlined";
import { Input as AntInput, Select } from "antd";

import CustomSelect from "../../../common-components/CustomSelect";
import CustomTextField from "../../../common-components/CustomTextField";
import FileUpload from "../../../common-components/FileUpload";
import {
  convertValuesFM,
  validateTwoDecimals,
  getResponse,
  getPaginationPageNumber,
  AddCommas,
  downloadFile,
} from "../../../shared-resources/utils";
import { getPayloadTzAbbr } from "../tzUtils";
import {
  getFringeDropdownAPI,
  getFringeHeaderAPI,
  getFringeAPI,
  postFringeAPI,
  deleteFringeAPI,
  deleteFringeNoteAPI,
  updateFringeAPI,
  updateFringenotesAPI,
  getAccountDropdownAPI,
  downloadFringeAPI,
  uploadFringePlanFileAPI,
  getFringePlanFilesAPI,
  downloadFringePlanFileAPI,
  deleteFringePlanFileAPI,
} from "../../../api/financial-management-api";
import Loading from "../../../common-components/Loading";
import ActionMessages from "../../../common-components/ActionMessages";
import ConfirmationDialog from "../../../common-components/ConfirmationDialog";
import { DownloadIcon, UploadIcon } from "../../../shared-resources/SVGIcons";

const { TextArea } = AntInput;

const useStyles = makeStyles((theme) => ({
  selctLabel: {
    textAlign: "center",
    alignContent: "center",
  },
  tableTitle: {
    width: "220px",
    height: "36px",
    padding: "0 0 0 12px",
    fontSize: "15px",
    color: "#ffffff",
    backgroundColor: "#000",
    borderRadius: "0 10px 0 0",
    display: "flex",
    alignItems: "center",
  },
  utilizationLabel: {
    width: "130px",
    textAlign: "center",
    alignContent: "center",
  },
  indirectLabel: {
    width: "150px",
  },
  editIcon: {
    color: "#0070D2",
    fontSize: "14px",
    float: "left",
    marginTop: "2px",
  },
  editText: {
    color: "#0070D2",
    marginLeft: "4px",
    fontWeight: 600,
    fontSize: "13px",
  },
  editBtn: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "2px 8px",
    cursor: "pointer",
  },
  cancelBtn: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "4px 20px",
    cursor: "pointer",
  },
  saveBtn: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "4px 20px",
    cursor: "pointer",
    marginRight: "8px",
  },
  popupBtn: {
    fontSize: "12px",
    padding: "4px 8px !important",
    textTransform: "none",
    background: "#0176D3",
    marginRight: "8px",
  },

  newClass: {
    backgroundColor: "#f0f0f0",
    padding: "10px",
    borderRadius: "5px",
  },
  inputStyle: {
    width: "85px",
    border: "1px solid #ccc",
    borderRadius: "3px",
    padding: "2px",
  },
  centerAlignedData: {
    textAlign: "right",
  },
  addColumnTitle: {
    height: "28px",
    textAlign: "center",
    marginBottom: "11px",
    fontWeight: 600,
    paddingTop: "5px",
    color: "#ffff",
  },
  addDialog: {
    width: "700px",
    height: "auto",
    position: "relative",
  },
  popupHeader: {
    marginTop: "-20px",
    marginLeft: "-24px",
    marginRight: "-24px",
    background: "#4b5558",
  },
  closeIconAdd: {
    display: "inline-block",
    color: "black",
    background: "#ffff",
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    cursor: "pointer",
    textAlign: "center",
    position: "absolute",
    top: "5px",
    right: "8px",
    fontSize: "13px",
    fontWeight: 600,
  },
  popupBtnsAdd: {
    textAlign: "center",
    marginTop: "24px",
  },
  cancelBtnPopup: {
    fontSize: "12px",
    padding: "3px 8px !important",
    textTransform: "none",
    border: "0.5px solid #0176D3",
    color: "#0176D3",
  },
  fieldTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.25),
    fontSize: "13px",
  },
  // "Bulk Upload" drawer for Fringe plan files — same chrome as Indirect's own upload drawer
  // (IndirectSummaryTab.js) and Weekly EAC's (WeeklyEACTemplateActions.js), kept visually
  // consistent across every upload flow in the app.
  uploadDrawerSection: {
    width: "420px",
    position: "relative",
    padding: theme.spacing(0.75, 4),
  },
  uploadDrawerClose: {
    position: "absolute",
    cursor: "pointer",
    right: theme.spacing(0.25),
    top: theme.spacing(0.25),
  },
  uploadDrawerCloseIcon: {
    color: "#C4C4C4",
  },
  uploadDrawerTitle: {
    color: "#0082CA",
    fontSize: theme.spacing(2.25),
    marginBottom: theme.spacing(2),
  },
  uploadDrawerDescription: {
    marginBottom: theme.spacing(2),
  },
  uploadDrawerError: {
    color: "#c0392b",
    marginBottom: theme.spacing(2),
  },
  tableScrollPane: {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    background: "#fff",
    boxShadow: "0px 3px 6px #00000029",
  },
  tableHeaderPane: {
    overflowX: "hidden",
    overflowY: "hidden",
  },
  tableBodyPane: {
    display: "flex",
    flexDirection: "row",
    overflow: "hidden",
  },
  leftPane: {
    width: 630,
    flexShrink: 0,
    background: "#fff",
    boxShadow: "2px 0 6px #00000029",
    zIndex: 2,
    position: "relative",
  },
  rightPane: {
    flex: 1,
    minWidth: 0,
    background: "#fff",
    boxShadow: "0px 3px 6px #00000029",
  },
  leftBodyScroll: {
    width: 630,
    flexShrink: 0,
    maxHeight: "calc(100vh - 320px)",
    overflowY: "auto",
    overflowX: "hidden",
    background: "#fff",
    boxShadow: "2px 0 6px #00000029",
    zIndex: 2,
    position: "relative",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  rightBodyScroll: {
    flex: 1,
    minWidth: 0,
    maxHeight: "calc(100vh - 320px)",
    overflow: "auto",
    background: "#fff",
    boxShadow: "0px 3px 6px #00000029",
  },
  stickyTotalCell: {
    position: "sticky",
    top: 0,
    zIndex: 2,
    background: "#fff",
    fontWeight: "bold",
    boxShadow: "0 2px 4px #00000029",
    borderBottom: "1px solid #ccc",
  },
}));

const months = [
  "jan",
  "feb",
  "mar",
  "apr",
  "may",
  "jun",
  "jul",
  "aug",
  "sep",
  "oct",
  "nov",
  "dec",
];

const defaultFringeData = {
  acctId: null,
  notes: "",
  totalAmount: 0,
  financialYear: null,
};
const Fringe = ({ isEdit, setIsEdit }) => {
  const [loading, setLoading] = useState(true);
  const [downloading, setDownloading] = useState(false);
  const classes = useStyles();
  const [yearValue, setYearValue] = useState("");
  const [version, setVersion] = useState("");
  const [versionStatus, setVersionStatus] = useState("");
  const [financialYears, setFinancialYears] = useState([]);
  const [versions, setVersions] = useState([]);
  const [revenue, setRevenue] = useState();
  const [fringeDropdown, setFringeDropdown] = useState([]);
  const [accountDropdown, setAccountDropdown] = useState([]);
  const [monthsHeader, setMonthsHeader] = useState([]);
  const [fringeData, setFringeData] = useState([]);
  const [editingFringeData, setEditingFringeData] = useState([]);
  const [showDialogNew, setShowDialogNew] = useState(false);
  const [isEditDetails, setIsEditDetails] = useState(false);
  const [fringeFormData, setFringeFormData] = useState(defaultFringeData);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteItem, setDeleteItem] = useState("");
  // Distinguishes what the shared ConfirmationDialog below is actually deleting — a fringe row
  // (pre-existing, deleteFringeAPI) or a plan-file attachment (new, deleteFringePlanFileAPI).
  const [deleteType, setDeleteType] = useState("fringe");
  // Excel plan-file attachments (upload/list/download/delete) against the currently selected
  // budget version — Phase 1, stored as-is, no parsing. Separate storage from Indirect's own
  // plan files. See APIIntegrationFiles/FRINGE_BUDGET_VERSION_FRONTEND_GUIDE.md §4.
  const [showUploadDrawer, setShowUploadDrawer] = useState(false);
  const [showPlanFilesDialog, setShowPlanFilesDialog] = useState(false);
  const [planFiles, setPlanFiles] = useState([]);
  const [planFilesLoading, setPlanFilesLoading] = useState(false);
  const [planFileUploading, setPlanFileUploading] = useState(false);
  const [planFileError, setPlanFileError] = useState("");
  const [msgType, setMsgType] = useState();
  const [msgText, setMsgText] = useState();
  const [emptyErrMsg, setEmptyErrMsg] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [fringeNotesHistory, setFringeNotesHistory] = useState([]);
  const rightHeaderScrollRef = useRef(null);
  const rightBodyScrollRef = useRef(null);
  const leftBodyScrollRef = useRef(null);
  const isSyncingScroll = useRef(false);

  const syncHorizontalScroll = (scrollLeft) => {
    if (rightHeaderScrollRef.current) {
      rightHeaderScrollRef.current.scrollLeft = scrollLeft;
    }
  };

  const syncVerticalScroll = (source) => {
    if (isSyncingScroll.current) return;
    isSyncingScroll.current = true;
    const from =
      source === "left"
        ? leftBodyScrollRef.current
        : rightBodyScrollRef.current;
    const to =
      source === "left"
        ? rightBodyScrollRef.current
        : leftBodyScrollRef.current;
    if (from && to) to.scrollTop = from.scrollTop;
    requestAnimationFrame(() => {
      isSyncingScroll.current = false;
    });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const BootstrapInput = withStyles((theme) => ({
    root: { "label + &": { marginTop: theme.spacing(3) } },
    input: {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid #ced4da !important",
      fontSize: 13,
      padding: "4px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      "&:focus": {
        borderRadius: 4,
        borderColor: "#80bdff",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
  }))(InputBase);
  useEffect(() => {
    setLoading(true);
    getFringeDropdownAPI().then((res) => {
      setLoading(false);
      if (res && res.status === 200) {
        const data = res.data;
        setFringeDropdown(data);

        const years = data
          .map((item) => ({
            id: item.financialYear,
            text: item.financialYear,
            value: item.financialYear,
            label: item.financialYear,
          }))
          .sort((a, b) => (a.id > b.id ? 1 : b.id > a.id ? -1 : 0));
        setFinancialYears(years);

        if (years.length > 0) {
          const currentYear = new Date().getFullYear();
          const presentYear =
            years.find((y) => y.id === currentYear) ?? years[0];
          setYearValue(presentYear.id);

          const defaultVersions = getVersionsByYear(data, presentYear.id);
          setVersions(defaultVersions);
          if (defaultVersions.length > 0) {
            setVersion(defaultVersions[0].id);
            setVersionStatus(defaultVersions[0].status);
          }
        }
      }
      if (res && res.status === 400) {
        setLoading(false);
      }
    });
    getAccountDropdownAPI("FRINGE").then((res) => {
      if (res && res.status === 200) {
        const accounts = res.data.map((item) => ({
          value: item.acct_id,
          label: item.display_text,
        }));
        setAccountDropdown(accounts);
      }
    });
  }, []);

  const getVersionsByYear = (data, selectedYear) => {
    const yearData = data.find(
      (item) => item.financialYear === Number(selectedYear),
    );
    if (!yearData) return [];
    return yearData.version.map((v) => ({
      id: v.version,
      text: v.versionName,
      status: v.status,
      isBudget: v.isBudget,
      isEditableBudget: v.isEditableBudget,
    }));
  };

  const onChangeYear = (selectedYear) => {
    setYearValue(selectedYear);

    const updatedVersions = getVersionsByYear(fringeDropdown, selectedYear);
    setVersions(updatedVersions);

    if (updatedVersions.length > 0) {
      setVersion(updatedVersions[0].id);
      setVersionStatus(updatedVersions[0].status);
    } else {
      setVersion("");
      setVersionStatus("");
    }
  };

  const onChangeVersion = (selectedId) => {
    const selected = versions.find((v) => v.id === Number(selectedId));
    if (selected) {
      setVersion(selected.id);
      setVersionStatus(selected.status);
    }
  };
  const onChangeFormFringeData = (e, key) => {
    setFringeFormData({ ...fringeFormData, [key]: e.target.value });
  };

  const onChangeFormFringeSelect = (val, key) => {
    setFringeFormData({ ...fringeFormData, [key]: val });
  };

  const isClosed = (val) => {
    setEmptyErrMsg(!val);
  };
  // Keeps each note's index in the RAW backend listOfNotes array (what delete-fringe-note's
  // noteIndex refers to) attached as `idx`, surviving both the blank-entry filter and the
  // newest-first reverse used for display — so a displayed row's own idx can be sent straight
  // to the delete API instead of re-deriving it (which breaks the moment a blank entry anywhere
  // in the raw array shifts every later index).
  const toNotesHistory = (raw) => {
    const notes = Array.isArray(raw) ? raw : raw ? [raw] : [];
    return notes
      .map((text, idx) => ({ text, idx }))
      .filter((entry) => entry.text && entry.text.trim() !== "")
      .reverse();
  };

  const onClickRevenueDetails = (item) => {
    setIsEditDetails(true);
    setRevenue({ id: item.id });
    setFringeNotesHistory(toNotesHistory(item.listOfNotes));
    setFringeFormData({ ...fringeFormData, notes: "" });
    setShowDialogNew(true);
  };
  const onDeleteIconClick = (item) => {
    setDeleteItem(item.id);
    setDeleteType("fringe");
    setConfirmOpen(true);
  };

  // Opens the same shared ConfirmationDialog used for deleting a fringe row, instead of
  // deleting immediately — actual deletion happens in okConfirmClick's "fringeNote" branch. `i`
  // is the clicked entry's position in the DISPLAYED list; its `idx` is the position in the
  // backend's raw listOfNotes array (per toNotesHistory above), which is what noteIndex means.
  const handleDeleteFringeNote = (i) => {
    setDeleteItem({ id: revenue?.id, noteIndex: fringeNotesHistory[i]?.idx });
    setDeleteType("fringeNote");
    setConfirmOpen(true);
  };
  const onDeletePlanFileClick = (file) => {
    setDeleteItem(file.id);
    setDeleteType("planFile");
    setConfirmOpen(true);
  };
  const cancelConfirmClick = () => {
    setConfirmOpen(false);
    setDeleteItem("");
    setDeleteType("fringe");
  };

  const okConfirmClick = async (val) => {
    if (!val) return;

    if (deleteType === "fringeNote") {
      setLoading(true);
      const res = await deleteFringeNoteAPI(deleteItem);
      setConfirmOpen(false);
      setDeleteItem("");
      setDeleteType("fringe");
      setLoading(false);

      if (res?.status === 200) {
        setEmptyErrMsg(true);
        setMsgType("success");
        setMsgText("Note deleted successfully.");
        const updatedNotes = res.data?.notes ?? [];
        setFringeNotesHistory(toNotesHistory(updatedNotes));
        // Patch the underlying row too, not just this dialog's local history state —
        // otherwise closing and reopening "View" re-reads the table's stale
        // item.listOfNotes and the just-deleted note reappears.
        setFringeData((prev) =>
          prev.map((row) =>
            row.id === deleteItem.id
              ? { ...row, listOfNotes: updatedNotes }
              : row,
          ),
        );
      } else {
        setEmptyErrMsg(true);
        setMsgType("error");
        setMsgText(res?.message || "Failed to delete note.");
      }
      return;
    }

    // Plan-file deletes are self-contained to the Attachments dialog — they use its own
    // loading/error state (planFilesLoading/planFileError, already shown inside that dialog)
    // rather than the page-wide loading overlay/ActionMessages toast the fringe-row delete
    // below uses, and refresh via fetchPlanFiles() instead of re-fetching the fringe grid.
    // See FRINGE_BUDGET_VERSION_FRONTEND_GUIDE.md §4.
    if (deleteType === "planFile") {
      setPlanFilesLoading(true);
      const deleteResponse = await deleteFringePlanFileAPI(deleteItem);
      setConfirmOpen(false);
      setDeleteItem("");
      setDeleteType("fringe");
      setPlanFilesLoading(false);
      if (deleteResponse?.status === 200) {
        setPlanFileError("");
        fetchPlanFiles();
      } else {
        setPlanFileError(
          deleteResponse?.message || "Unable to delete the file.",
        );
      }
      return;
    }

    setLoading(true);
    deleteFringeAPI(deleteItem).then((res) => {
      if (res.status === 200) {
        setLoading(false);
        setConfirmOpen(false);
        getFringeAPI(yearValue, version).then((response) => {
          setFringeData(response.data);
        });

        setDeleteItem("");
        setEmptyErrMsg(true);
        setMsgType("success");
        setMsgText("Item deleted successfully");
      } else {
        setLoading(false);
        setConfirmOpen(false);
        setDeleteItem("");
        setEmptyErrMsg(true);
        setMsgType("error");
        setMsgText(res.message);
      }
    });
  };
  const handleAddNewLabor = () => {
    setShowDialogNew(true);
    setFringeFormData(defaultFringeData);
  };
  const onAddFringe = () => {
    if (isEditDetails) {
      setLoading(true);
      const username =
        localStorage.getItem("Login_User_Name") ||
        localStorage.getItem("email") ||
        "";
      const now = new Date();
      const systemTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const tzAbbr = getPayloadTzAbbr();
      const datePart = now
        .toLocaleDateString("en-US", {
          timeZone: systemTz,
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        })
        .replace(/\//g, "-");
      const timePart = now.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
        timeZone: systemTz,
      });
      const formattedTimestamp = `${datePart} ${timePart} ${tzAbbr}`;
      const insertData = {
        id: revenue.id,
        notes: fringeFormData.notes
          ? `${username} - ${formattedTimestamp} - ${fringeFormData.notes}`
          : `${username} - ${formattedTimestamp}`,
      };
      updateFringenotesAPI(insertData).then((res) => {
        if (res.status === 200) {
          setShowDialogNew(false);
          setLoading(false);
          setMsgType("success");
          setEmptyErrMsg(true);
          setIsEditDetails(false);
          setMsgText("Notes added successfully");
          getFringeAPI(yearValue, version).then((response) => {
            if (response.status === 200) {
              setFringeData(response.data);
            }
          });
        }
        if (res.status === 400) {
          setLoading(false);
          setMsgType("error");
          setEmptyErrMsg(true);
          setMsgText(res.message);
        }
      });
    } else {
      setLoading(true);
      postFringeAPI(fringeFormData, version).then((res) => {
        if (res.status === 200) {
          setShowDialogNew(false);
          setLoading(false);
          setMsgType("success");
          setEmptyErrMsg(true);
          setMsgText("Item added successfully");
          getFringeAPI(yearValue, version).then((response) => {
            if (response.status === 200) {
              setFringeData(response.data);
            }
          });
        }
        if (res.status === 400) {
          setLoading(false);
          setMsgType("error");
          setEmptyErrMsg(true);
          setMsgText(res.message);
        }
      });
    }
  };
  useEffect(() => {
    if (yearValue && (version || version === 0)) {
      setLoading(true);
      getFringeAPI(yearValue, version).then((res) => {
        setLoading(false);
        setFringeData(res.data);
        setRowsPerPage(res.data.length || 10);
        setPage(0);
      });
    }
  }, [yearValue, version]);
  useEffect(() => {
    if (yearValue && (version || version === 0)) {
      setLoading(true);
      getFringeHeaderAPI(yearValue, version).then((res) => {
        setLoading(false);
        setMonthsHeader(res.data);
      });
    }
  }, [yearValue, version]);
  const handleEdit = () => {
    setEditingFringeData(JSON.parse(JSON.stringify(fringeData)));
    setIsEdit(true);
  };
  const handleCancel = () => {
    setEditingFringeData([]);
    setIsEdit(false);
  };

  const onChangeMonthValue = (e, itemIndex, month) => {
    const input = e.target;
    const cursorPos = input.selectionStart;
    const oldValue = input.value;
    const value = oldValue.replace(/,/g, "");
    if (value !== "" && !/^-?\d*\.?\d*$/.test(value)) return;
    const commasBefore = (oldValue.slice(0, cursorPos).match(/,/g) || [])
      .length;
    const newFormatted = AddCommas(value === "" ? 0 : value);
    const commasAfter = (
      String(newFormatted).slice(0, cursorPos).match(/,/g) || []
    ).length;
    const newCursorPos = cursorPos + (commasAfter - commasBefore);
    const updatedData = [...editingFringeData];
    updatedData[itemIndex] = {
      ...updatedData[itemIndex],
      [month]: value === "" ? 0 : value,
      isUpdated: true,
    };
    setEditingFringeData(updatedData);
    requestAnimationFrame(() => {
      input.setSelectionRange(newCursorPos, newCursorPos);
    });
  };
  const onSaveClick = async () => {
    setLoading(true);
    const dataToUpdate = editingFringeData.filter((item) => item.isUpdated);

    if (dataToUpdate.length === 0) {
      setLoading(false);
      setMsgType("warning");
      setEmptyErrMsg(true);
      setMsgText("No changes to save.");
      return;
    }

    try {
      const response = await updateFringeAPI(version, dataToUpdate);
      if (response && response.status === 200) {
        setLoading(false);
        setIsEdit(false);
        setEditingFringeData([]);
        setMsgType("success");
        setEmptyErrMsg(true);
        setMsgText("Fringe data updated successfully");
        getFringeAPI(yearValue, version).then((response) => {
          setFringeData(response.data);
        });
      } else {
        setLoading(false);
        setMsgType("error");
        setEmptyErrMsg(true);
        setMsgText(response?.message || "Failed to update fringe data.");
      }
    } catch (error) {
      setLoading(false);
      setMsgType("error");
      setEmptyErrMsg(true);
      setMsgText("An error occurred while updating fringe data.");
    }
  };

  const handleDownloadFringe = () => {
    setDownloading(true);
    const versionName = versions.find((v) => v.id === version)?.text ?? version;
    downloadFringeAPI(yearValue, version).then((res) => {
      setDownloading(false);
      if (res?.type) {
        downloadFile(res, `fringe_${yearValue}_${versionName}`);
      }
    });
  };

  const fetchPlanFiles = () => {
    if (!version && version !== 0) return;
    setPlanFilesLoading(true);
    getFringePlanFilesAPI(version).then((res) => {
      setPlanFilesLoading(false);
      if (res?.status === 200) {
        setPlanFiles(res.data || []);
      } else {
        // The list API 400s once there are no files left for this version instead of
        // returning 200 with an empty array — treat that as "no attachments" rather than
        // leaving the just-deleted file stuck on screen from the previous fetch.
        setPlanFiles([]);
      }
    });
  };

  const handleOpenUploadDrawer = () => {
    setPlanFileError("");
    setShowUploadDrawer(true);
  };

  const handleOpenPlanFiles = () => {
    setPlanFileError("");
    setShowPlanFilesDialog(true);
    fetchPlanFiles();
  };

  // Upload only succeeds while `version` is currently the editable budget version — the API
  // itself enforces that (400 otherwise), so no further client-side detection is added here.
  const handleUploadPlanFile = (formData) => {
    formData.append("version", version);
    if (yearValue) formData.append("financialYear", yearValue);

    setPlanFileError("");
    setPlanFileUploading(true);
    uploadFringePlanFileAPI(formData)
      .then((res) => {
        setPlanFileUploading(false);
        if (res?.status === 200) {
          setShowUploadDrawer(false);
          fetchPlanFiles();
        } else {
          setPlanFileError(
            res?.message ||
              "Unable to upload the file. Please check the file and try again.",
          );
        }
      })
      .catch(() => {
        setPlanFileUploading(false);
        setPlanFileError("Something went wrong during the upload.");
      });
  };

  const handleDownloadPlanFile = (file) => {
    downloadFringePlanFileAPI(file.id).then((res) => {
      if (res?.type) {
        downloadFile(res, file.fileName);
      }
    });
  };

  // From GET /financial/indirect/fringe-dropdown (already live) — `isBudget` identifies any
  // version whose name matches the "budget" pattern regardless of year (used to keep the
  // Attachments icon/list reachable even for an expired budget version); `isEditableBudget`
  // is true only while that budget-only edit bypass is currently active (used to gate Upload
  // and every write affordance, same as Indirect's isEditableBudget). See
  // FRINGE_BUDGET_VERSION_FRONTEND_GUIDE.md §2.
  const selectedVersionOption = versions.find((v) => v.id === version);
  const isBudgetVersion = Boolean(selectedVersionOption?.isBudget);
  const isEditableBudget = Boolean(selectedVersionOption?.isEditableBudget);

  return (
    <>
      <Grid item lg={12}>
        {/* Same left-to-right order as the Indirect screen's icon row (Download, Upload,
            Attachments) — with float: right stacking, that means DOM order Attachments, then
            Upload, then Download, since each new float:right sibling lands immediately to the
            LEFT of the previous one. Both Attachments and Upload only show while the selected
            version is currently the editable budget version — an expired budget version hides
            both. See FRINGE_BUDGET_VERSION_FRONTEND_GUIDE.md §2/§4. */}
        {isBudgetVersion && isEditableBudget && (
          <div
            style={{
              float: "right",
              marginRight: "8px",
              marginTop: "8px",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: "24px",
              height: "24px",
              borderRadius: "6px",
              background: isEdit ? "#ccc" : "#0070D2",
              boxShadow: "0px 1px 3px rgba(0,0,0,0.161)",
              cursor: isEdit ? "default" : "pointer",
            }}
            title={!isEdit ? "Attachments" : ""}
            onClick={isEdit ? undefined : handleOpenPlanFiles}
          >
            <AttachFileIcon style={{ color: "#fff", fontSize: 16 }} />
          </div>
        )}
        {isBudgetVersion &&
          isEditableBudget &&
          localStorage.getItem("accessType") === "RW" && (
            <div
              style={{
                float: "right",
                marginRight: "8px",
                marginTop: "2px",
                position: "relative",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: "30px",
                height: "30px",
                cursor: isEdit ? "default" : "pointer",
              }}
              title={!isEdit ? "Upload Attachments" : ""}
              onClick={isEdit ? undefined : handleOpenUploadDrawer}
            >
              <UploadIcon
                background={isEdit ? "#ccc" : "#0070D2"}
                color="#fff"
                width="30"
                height="30"
              />
              <span
                style={{
                  position: "absolute",
                  right: "-2px",
                  bottom: "-2px",
                  width: "14px",
                  height: "14px",
                  borderRadius: "50%",
                  background: "#fff",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0px 1px 2px rgba(0,0,0,0.25)",
                }}
              >
                <AttachFileIcon
                  style={{ fontSize: 9, color: isEdit ? "#ccc" : "#0070D2" }}
                />
              </span>
            </div>
          )}
        <div
          style={{
            float: "right",
            marginTop: "2px",
          }}
        >
          <span
            style={{
              cursor: isEdit ? "default" : "pointer",
              display: "inline-flex",
            }}
            title={!isEdit ? "Download" : ""}
            onClick={isEdit ? undefined : handleDownloadFringe}
          >
            <DownloadIcon
              background={isEdit ? "#ccc" : "#0070D2"}
              color="#fff"
              width="30"
              height="30"
            />
          </span>
        </div>
        <div
          className="clearfix"
          style={{
            float: "right",
            marginRight: "32px",
            marginTop: "2px",
          }}
        >
          <CustomSelect
            selectedValue={version}
            onChangeItem={(e) => onChangeVersion(e.target.value)}
            labelVal="Version"
            id="version"
            items={versions}
            width="150px"
            borderColor="#000"
          />
        </div>
        <div
          style={{
            float: "right",
            margin: "6px  8px 0 0",
            fontWeight: 600,
          }}
        >
          Select Version
        </div>
        <div
          className="clearfix"
          style={{
            float: "right",
            marginRight: "32px",
            marginTop: "2px",
          }}
        >
          <CustomSelect
            selectedValue={yearValue}
            onChangeItem={(e) => onChangeYear(e.target.value)}
            labelVal="Year"
            id="Year"
            items={financialYears}
            width="120px"
            borderColor="#000"
          />
        </div>
        <div
          style={{
            float: "right",
            margin: "6px  8px 0 0",
            fontWeight: 600,
          }}
        >
          Select Year
        </div>
      </Grid>

      <Grid item lg={12}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          style={{ marginTop: "56px" }}
        >
          <div className={classes.tableTitle}>Indirect Non-Labor</div>

          {((versionStatus.toLowerCase() === "open" &&
            localStorage.getItem("accessType") === "RW") ||
            isEditableBudget) && (
            <Box>
              {!isEdit ? (
                <div className={classes.editBtn} onClick={handleEdit}>
                  <EditIcon className={classes.editIcon} />
                  <span className={classes.editText}> Edit </span>
                </div>
              ) : (
                <>
                  <span className={classes.saveBtn} onClick={onSaveClick}>
                    {" "}
                    Save{" "}
                  </span>
                  <span className={classes.cancelBtn} onClick={handleCancel}>
                    Cancel
                  </span>
                </>
              )}
            </Box>
          )}
        </Box>
      </Grid>

      <Box>
        {fringeData && fringeData.length > 0 ? (
          <div>
            <Box className={classes.tableScrollPane}>
              {/* Fixed headers */}
              <Box
                display="flex"
                flexDirection="row"
                style={{
                  flexShrink: 0,
                  background: "#fff",
                  zIndex: 3,
                }}
              >
                <Box className={classes.leftPane}>
                  <table
                    className="firstTableFin"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <thead>
                      <tr>
                        <th style={{ minWidth: "24px", maxWidth: "24px" }}></th>
                        <th style={{ minWidth: "150px", maxWidth: "150px" }}>
                          Account Id
                        </th>
                        <th style={{ minWidth: "210px", maxWidth: "210px" }}>
                          Account Name
                        </th>
                        <th style={{ minWidth: "115px", maxWidth: "115px" }}>
                          Details
                        </th>
                        <th style={{ minWidth: "130px", maxWidth: "130px" }}>
                          Cost Type
                        </th>
                      </tr>
                    </thead>
                  </table>
                </Box>
                <Box
                  ref={rightHeaderScrollRef}
                  className={`${classes.tableHeaderPane} ${classes.rightPane}`}
                >
                  <table
                    className="secondTableFin"
                    cellPadding={0}
                    cellSpacing={0}
                    width={"1500"}
                  >
                    <thead>
                      <tr>
                        {monthsHeader.map((item, i) => (
                          <th
                            rowSpan={1}
                            key={i}
                            style={{
                              minWidth: "120px",
                              maxWidth: "120px",
                            }}
                            className="centerAlignedHeaderLeftBorder"
                          >
                            {item.heading}
                          </th>
                        ))}
                        <th
                          rowSpan={2}
                          style={{
                            minWidth: "120px",
                            maxWidth: "120px",
                          }}
                          className="centerAlignedHeaderLeftBorder"
                        >
                          Total
                        </th>
                      </tr>
                      <tr>
                        {monthsHeader.map((item, i) => (
                          <th
                            key={i}
                            rowSpan={1}
                            className={
                              item.type === "Actual"
                                ? "actualHeaderCost"
                                : "forecastHeaderCost"
                            }
                            style={{
                              minWidth: "120px",
                              maxWidth: "120px",
                              padding: "0px 10px",
                              textAlign: "center",
                            }}
                          >
                            {item.type}
                          </th>
                        ))}
                      </tr>
                    </thead>
                  </table>
                </Box>
              </Box>

              {/* Scrollable data rows */}
              <Box className={classes.tableBodyPane}>
                <Box
                  ref={leftBodyScrollRef}
                  className={classes.leftBodyScroll}
                  onScroll={() => syncVerticalScroll("left")}
                >
                  <table
                    className="firstTableFin"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <tbody>
                      <tr>
                        <td
                          style={{ minWidth: "24px", maxWidth: "24px" }}
                          className={classes.stickyTotalCell}
                        ></td>
                        <td colSpan={4} className={classes.stickyTotalCell}>
                          Total
                        </td>
                      </tr>
                      {(isEdit ? editingFringeData : fringeData)
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage,
                        )
                        .map((item, i) => (
                          <tr key={i}>
                            <td style={{ minWidth: "24px", maxWidth: "24px" }}>
                              {((versionStatus.toLowerCase() === "open" &&
                                localStorage.getItem("accessType") === "RW") ||
                                isEditableBudget) && (
                                <DeleteForeverIcon
                                  style={{
                                    color: "red",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    float: "left",
                                  }}
                                  onClick={() => onDeleteIconClick(item)}
                                />
                              )}
                            </td>
                            <td
                              style={{ minWidth: "150px", maxWidth: "150px" }}
                              title={item.acctId}
                            >
                              {item.acctId}
                            </td>
                            <td
                              style={{ minWidth: "210px", maxWidth: "210px" }}
                              title={item.acctName}
                            >
                              {item.acctName}
                            </td>
                            <td
                              style={{ minWidth: "115px", maxWidth: "115px" }}
                            >
                              <span
                                style={{
                                  fontWeight: 600,
                                  color: "#09659c",
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                                onClick={() => onClickRevenueDetails(item)}
                              >
                                View
                              </span>
                            </td>
                            <td
                              style={{ minWidth: "130px", maxWidth: "130px" }}
                              title={item.costType}
                            >
                              {item.costType}
                            </td>
                          </tr>
                        ))}
                      {!isEdit &&
                        ((versionStatus.toLowerCase() === "open" &&
                          localStorage.getItem("accessType") === "RW") ||
                          isEditableBudget) && (
                          <tr>
                            <td
                              style={{ minWidth: "24px", maxWidth: "24px" }}
                            ></td>
                            <td colSpan={4}>
                              <span
                                style={{
                                  cursor: "pointer",
                                  color: "#09659c",
                                  fontWeight: 600,
                                }}
                                onClick={() => handleAddNewLabor()}
                              >
                                + Add New
                              </span>
                            </td>
                          </tr>
                        )}
                    </tbody>
                  </table>
                </Box>
                <Box
                  ref={rightBodyScrollRef}
                  className={classes.rightBodyScroll}
                  onScroll={(e) => {
                    syncHorizontalScroll(e.currentTarget.scrollLeft);
                    syncVerticalScroll("right");
                  }}
                >
                  <table
                    className="secondTableFin"
                    cellPadding={0}
                    cellSpacing={0}
                    width={"1500"}
                  >
                    <tbody>
                      <tr>
                        {months.map((month, i) => {
                          const total = (
                            isEdit ? editingFringeData : fringeData
                          ).reduce(
                            (sum, item) => sum + (Number(item[month]) || 0),
                            0,
                          );

                          return (
                            <td
                              key={i}
                              style={{
                                minWidth: "120px",
                                maxWidth: "120px",
                              }}
                              className={`${classes.centerAlignedData} ${classes.stickyTotalCell}`}
                            >
                              {convertValuesFM(total)}
                            </td>
                          );
                        })}

                        <td
                          style={{
                            minWidth: "120px",
                            maxWidth: "120px",
                          }}
                          className={`${classes.centerAlignedData} ${classes.stickyTotalCell}`}
                        >
                          {convertValuesFM(
                            (isEdit ? editingFringeData : fringeData).reduce(
                              (sum, item) =>
                                sum +
                                months.reduce(
                                  (s, m) => s + (Number(item[m]) || 0),
                                  0,
                                ),
                              0,
                            ),
                          )}
                        </td>
                      </tr>
                      {(isEdit ? editingFringeData : fringeData)
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage,
                        )
                        .map((item, i) => {
                          const actualIndex = page * rowsPerPage + i;
                          const rowTotal = months.reduce(
                            (sum, m) => sum + (Number(item[m]) || 0),
                            0,
                          );

                          return (
                            <tr key={actualIndex}>
                              {months.map((month, j) => (
                                <td
                                  key={j}
                                  style={{
                                    minWidth: "120px",
                                    maxWidth: "120px",
                                  }}
                                  className={classes.centerAlignedData}
                                >
                                  {isEdit ? (
                                    monthsHeader[j]?.type === "Actual" ? (
                                      <>
                                        {item[month] === "" ||
                                        item[month] == null
                                          ? ""
                                          : convertValuesFM(item[month])}
                                      </>
                                    ) : (
                                      <input
                                        type="text"
                                        className={classes.inputStyle}
                                        value={AddCommas(item[month])}
                                        onChange={(e) =>
                                          onChangeMonthValue(
                                            e,
                                            actualIndex,
                                            month,
                                          )
                                        }
                                        onBlur={(e) => {
                                          const val = e.target.value.replace(
                                            /,/g,
                                            "",
                                          );
                                          const updatedData = [
                                            ...editingFringeData,
                                          ];
                                          updatedData[actualIndex] = {
                                            ...updatedData[actualIndex],
                                            [month]:
                                              val === "" || isNaN(Number(val))
                                                ? 0
                                                : Number(val),
                                          };
                                          setEditingFringeData(updatedData);
                                        }}
                                        style={{
                                          width: "100%",
                                          padding: "4px 2px",
                                          borderRadius: "3px",
                                          border: "1px solid #ccc",
                                        }}
                                      />
                                    )
                                  ) : (
                                    <>
                                      {item[month] === "" || item[month] == null
                                        ? ""
                                        : convertValuesFM(item[month])}
                                    </>
                                  )}
                                </td>
                              ))}
                              <td
                                style={{
                                  minWidth: "120px",
                                  maxWidth: "120px",
                                  fontWeight: "bold",
                                }}
                                className={classes.centerAlignedData}
                              >
                                {convertValuesFM(rowTotal)}
                              </td>
                            </tr>
                          );
                        })}
                      {!isEdit &&
                        ((versionStatus.toLowerCase() === "open" &&
                          localStorage.getItem("accessType") === "RW") ||
                          isEditableBudget) && (
                          <tr>
                            <td colSpan={months.length + 1}>&nbsp;</td>
                          </tr>
                        )}
                    </tbody>
                  </table>
                </Box>
              </Box>
            </Box>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-end"
              style={{ marginBottom: "32px", marginTop: "6px" }}
            >
              <Box display="flex" alignItems="center">
                <div style={{ marginRight: "8px" }}>
                  <div style={{ float: "left", marginTop: "4px" }}>Showing</div>
                  <FormControl className="tableRowsDdl">
                    <MuiSelect
                      value={rowsPerPage}
                      onChange={handleChangeRowsPerPage}
                      input={<BootstrapInput />}
                    >
                      <MenuItem value={5}>5</MenuItem>
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={15}>15</MenuItem>
                      <MenuItem value={20}>20</MenuItem>
                      <MenuItem value={25}>25</MenuItem>
                      <MenuItem value={fringeData.length}>
                        {fringeData.length}
                      </MenuItem>
                    </MuiSelect>
                  </FormControl>
                </div>
                <Pagination
                  count={Math.ceil(fringeData.length / rowsPerPage)}
                  showFirstButton
                  showLastButton
                  renderItem={(item) => (
                    <PaginationItem
                      {...item}
                      page={getPaginationPageNumber(
                        item.page - 1,
                        fringeData.length,
                        rowsPerPage,
                      )}
                    />
                  )}
                  page={page + 1}
                  onChange={handleChangePage}
                  color="primary"
                />
              </Box>
            </Box>
          </div>
        ) : (
          <div
            style={{
              textAlign: "center",
              fontWeight: 600,
              background: "#fff",
              padding: "24px 0",
            }}
          >
            {!isEdit &&
            ((versionStatus.toLowerCase() === "open" &&
              localStorage.getItem("accessType") === "RW") ||
              isEditableBudget) ? (
              <span
                style={{
                  cursor: "pointer",
                  color: "#09659c",
                  fontWeight: 600,
                }}
                onClick={() => handleAddNewLabor()}
              >
                + Add New
              </span>
            ) : (
              "No Data"
            )}
          </div>
        )}
      </Box>
      {loading && <Loading />}
      {downloading && <Loading />}
      {showDialogNew && (
        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          maxWidth="lg"
          aria-labelledby="confirmation-dialog"
          open={showDialogNew}
        >
          <DialogContent className={classes.addDialog}>
            <div className={classes.popupHeader}>
              <span
                className={classes.closeIconAdd}
                onClick={() => {
                  setShowDialogNew(false);
                  setIsEditDetails(false);
                }}
              >
                x
              </span>
              <div className={classes.addColumnTitle}>
                {" "}
                {isEditDetails ? `Notes` : `Add New Fringe`}
              </div>
            </div>
            <Grid container spacing={2}>
              {!isEditDetails && (
                <>
                  <Grid item lg={6}>
                    <div className={classes.fieldTitle}>
                      Account ID
                      <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                    </div>
                    <Select
                      style={{ width: "95%", zIndex: 9, marginBottom: "12px" }}
                      placeholder="Select Account ID"
                      options={accountDropdown}
                      value={fringeFormData.acctId}
                      onChange={(val) =>
                        onChangeFormFringeSelect(val, "acctId")
                      }
                    />
                  </Grid>
                  <Grid item lg={6}>
                    <div className={classes.fieldTitle}>
                      Total Amount <span style={{ color: "red" }}>*</span>
                    </div>
                    <CustomTextField
                      selectedValue={fringeFormData.totalAmount}
                      onChangeItem={(e) =>
                        onChangeFormFringeData(e, "totalAmount")
                      }
                      labelVal="Total Amount"
                      id="totalAmount"
                      type="number"
                    />
                  </Grid>
                  <Grid item lg={6}>
                    <div className={classes.fieldTitle}>
                      Financial Year <span style={{ color: "red" }}>*</span>
                    </div>
                    <Select
                      style={{ width: "95%", zIndex: 9, marginBottom: "12px" }}
                      placeholder="Select Financial Year"
                      options={financialYears}
                      value={fringeFormData.financialYear}
                      onChange={(val) =>
                        onChangeFormFringeSelect(val, "financialYear")
                      }
                    />
                  </Grid>
                </>
              )}
              <Grid style={{ marginTop: "12px" }} item lg={12}>
                {!isEditDetails && (
                  <div className={classes.fieldTitle}>Notes</div>
                )}
                <TextArea
                  rows={6}
                  placeholder={
                    (versionStatus.toLowerCase() === "open" &&
                      localStorage.getItem("accessType") === "RW") ||
                    isEditableBudget
                      ? "Notes"
                      : ""
                  }
                  maxLength={2000}
                  className="indirectNotes"
                  disabled={
                    !(
                      (versionStatus.toLowerCase() === "open" &&
                        localStorage.getItem("accessType") === "RW") ||
                      isEditableBudget
                    )
                  }
                  value={fringeFormData.notes}
                  onChange={(e) => onChangeFormFringeData(e, "notes")}
                />
                {((versionStatus.toLowerCase() === "open" &&
                  localStorage.getItem("accessType") === "RW") ||
                  isEditableBudget) && (
                  <div className={classes.popupBtnsAdd}>
                    <Button
                      className={classes.popupBtn}
                      variant="contained"
                      color="primary"
                      onClick={() => onAddFringe()}
                      disabled={
                        (!isEditDetails &&
                          (!fringeFormData.acctId ||
                            !fringeFormData.financialYear ||
                            fringeFormData.totalAmount === 0)) ||
                        (isEditDetails && fringeFormData.notes === "")
                      }
                    >
                      Add
                    </Button>
                    <Button
                      variant="outlined"
                      className={classes.cancelBtnPopup}
                      color="primary"
                      onClick={() => {
                        setShowDialogNew(false);
                        setIsEditDetails(false);
                      }}
                    >
                      Cancel
                    </Button>
                  </div>
                )}
                {isEditDetails && fringeNotesHistory.length > 0 && (
                  <div
                    style={{
                      marginTop: "16px",
                      maxHeight: "200px",
                      overflowY: "auto",
                    }}
                  >
                    <table
                      className="firstTableFin"
                      cellPadding={0}
                      cellSpacing={0}
                      style={{ width: "100%", tableLayout: "fixed" }}
                    >
                      <thead>
                        <tr>
                          <th
                            style={{
                              height: "28px",
                              padding: "4px 8px",
                              width: "32px",
                            }}
                          ></th>
                          <th style={{ height: "28px", padding: "4px 8px" }}>
                            Notes History
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {fringeNotesHistory.map((entry, i) => (
                          <tr key={i}>
                            <td
                              style={{
                                padding: "4px 8px",
                                overflow: "visible",
                                textOverflow: "clip",
                                whiteSpace: "normal",
                              }}
                            >
                              <DeleteForeverIcon
                                style={{
                                  color: "red",
                                  fontSize: "18px",
                                  cursor: "pointer",
                                }}
                                titleAccess="Delete"
                                onClick={() => handleDeleteFringeNote(i)}
                              />
                            </td>
                            <td
                              style={{
                                padding: "4px 8px",
                                wordBreak: "break-word",
                                whiteSpace: "normal",
                              }}
                            >
                              {entry.text}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
      )}
      <Drawer
        anchor="right"
        open={showUploadDrawer}
        onClose={() => setShowUploadDrawer(false)}
      >
        <div className={classes.uploadDrawerSection}>
          <div className={classes.uploadDrawerTitle}>Bulk Upload</div>
          <div className={classes.uploadDrawerDescription}>
            Please Drag and Drop or select the required files
          </div>
          <div
            className={classes.uploadDrawerClose}
            onClick={() => setShowUploadDrawer(false)}
          >
            <CloseIcon className={classes.uploadDrawerCloseIcon} />
          </div>
          {planFileError && (
            <div className={classes.uploadDrawerError}>{planFileError}</div>
          )}
          <FileUpload getFormData={handleUploadPlanFile} fieldName="file" />
        </div>
        {planFileUploading && <Loading />}
      </Drawer>

      {showPlanFilesDialog && (
        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          maxWidth="md"
          aria-labelledby="fringe-plan-files-dialog"
          open={showPlanFilesDialog}
        >
          <DialogContent className={classes.addDialog}>
            <div className={classes.popupHeader}>
              <span
                className={classes.closeIconAdd}
                onClick={() => setShowPlanFilesDialog(false)}
              >
                x
              </span>
              <div className={classes.addColumnTitle}>Attachments</div>
            </div>

            {planFileError && (
              <div className={classes.uploadDrawerError}>{planFileError}</div>
            )}

            <table
              className="firstTableFin firstTableFinAttachemts"
              cellPadding={0}
              cellSpacing={0}
              style={{ width: "100%", tableLayout: "fixed" }}
            >
              <thead>
                <tr>
                  <th style={{ padding: "4px 8px" }}>File Name</th>
                  <th style={{ padding: "4px 8px" }}>Uploaded By</th>
                  <th style={{ padding: "4px 8px" }}>Uploaded At</th>
                  <th style={{ padding: "4px 8px", width: "100px" }}></th>
                </tr>
              </thead>
              <tbody>
                {planFiles.length > 0 ? (
                  planFiles.map((file) => (
                    <tr key={file.id}>
                      <td
                        style={{ padding: "4px 8px", wordBreak: "break-word" }}
                      >
                        {file.fileName}
                      </td>
                      <td style={{ padding: "4px 8px" }}>{file.uploadedBy}</td>
                      <td style={{ padding: "4px 8px" }}>
                        {file.uploadedAt
                          ? new Date(file.uploadedAt).toLocaleString()
                          : ""}
                      </td>
                      <td
                        style={{
                          padding: "4px 8px",
                          textAlign: "center",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                        }}
                      >
                        <span
                          style={{ cursor: "pointer" }}
                          title="Download"
                          onClick={() => handleDownloadPlanFile(file)}
                        >
                          <DownloadIcon
                            background="#0070D2"
                            color="#fff"
                            width="28"
                            height="28"
                          />
                        </span>
                        {isEditableBudget && (
                          <DeleteForeverIcon
                            style={{
                              color: "red",
                              fontSize: "20px",
                              cursor: "pointer",
                            }}
                            titleAccess="Delete"
                            onClick={() => onDeletePlanFileClick(file)}
                          />
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={4}
                      style={{
                        textAlign: "center",
                        padding: "8px",
                        color: "#888",
                      }}
                    >
                      {planFilesLoading
                        ? "Loading..."
                        : "No files uploaded yet"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </DialogContent>
          {planFilesLoading && <Loading />}
        </Dialog>
      )}
      {emptyErrMsg && (
        <ActionMessages type={msgType} isClosed={isClosed} message={msgText} />
      )}
      {confirmOpen && (
        <ConfirmationDialog
          cancelClick={cancelConfirmClick}
          okClick={okConfirmClick}
          confirmText="Do you want to delete this item?"
          closeDialog={() => setConfirmOpen(false)}
        />
      )}
    </>
  );
};
export default Fringe;
